import React, { useState, useEffect } from "react";
import Category from "../components/Category";
import HeroSlide from "../components/HeroSlide";
import ProductSlide from "../components/ProductSlide";
import axios from "axios";
import { baseurl, imgurl } from "../baseurl"; // Ensure imgurl is imported
import CategoryMobile from "../components/CategoryMobile";
import ProductCardSlideMobile from "./HomeCompo/ProductCardSlideMobile";

function Shipping() {
  
    return (
     <>
     
     <section className="container my-5">
        <h1>Shipping & Delivery Policy</h1>
    <p><strong>Subcity International Marketing Pvt Ltd</strong></p>
    <p><strong>Effective Date:</strong> 02/02/2026<br/>
    <strong>Last Updated:</strong> 02/02/2026</p>

    <p>This Shipping & Delivery Policy applies to all orders placed on the official e-commerce website of Subcity International Marketing Pvt Ltd (“Company”, “we”, “our”, “us”).</p>

    <hr/>

    <h2>1. Order Processing Time</h2>
    <ul>
        <li>Orders are processed within 1–3 working days after successful payment confirmation.</li>
        <li>Orders placed on Sundays or public holidays will be processed on the next working day.</li>
    </ul>

    <h2>2. Shipping Coverage</h2>
    <ul>
        <li>We currently ship across India.</li>
        <li>Delivery to remote or rural locations may take additional time depending on courier availability.</li>
    </ul>

    <h2>3. Estimated Delivery Time</h2>
    <ul>
        <li><strong>Metro Cities:</strong> 3–5 working days</li>
        <li><strong>Non-Metro / Tier-2 Cities:</strong> 5–7 working days</li>
        <li><strong>Remote Areas:</strong> 7–10 working days</li>
    </ul>
    <p>⏱ Delivery timelines are estimates and may vary due to logistics, weather conditions, or unforeseen circumstances.</p>

    <h2>4. Shipping Charges</h2>
    <ul>
        <li>Shipping charges (if any) are clearly mentioned at checkout before payment.</li>
        <li>Promotional offers such as free shipping may be available on selected products or order values.</li>
    </ul>

    <h2>5. Courier & Logistics Partners</h2>
    <ul>
        <li>Orders are shipped through reputed third-party courier services.</li>
        <li>Tracking details will be shared via SMS / Email once the order is dispatched.</li>
    </ul>

    <h2>6. Order Tracking</h2>
    <ul>
        <li>Customers can track their shipment using the tracking link or ID provided after dispatch.</li>
        <li>For assistance, customers may contact our support team.</li>
    </ul>

    <h2>7. Delivery Attempts</h2>
    <ul>
        <li>Courier partners usually attempt delivery 2–3 times.</li>
        <li>If delivery fails due to incorrect address, unavailability, or refusal, the order may be returned to origin.</li>
    </ul>

    <h2>8. Delayed Deliveries</h2>
    <p>The Company shall not be held liable for delays caused due to:</p>
    <ul>
        <li>Natural calamities</li>
        <li>Government restrictions</li>
        <li>Courier partner delays</li>
        <li>Incorrect or incomplete delivery address provided by the customer</li>
    </ul>

    <h2>9. Damaged or Tampered Packages</h2>
    <ul>
        <li>If the package appears damaged or tampered at the time of delivery, customers are advised not to accept the delivery and immediately inform us.</li>
        <li>If accepted, customers must report the issue within 48 hours of delivery with images.</li>
    </ul>

    <h2>10. Address Accuracy</h2>
    <ul>
        <li>Customers are responsible for providing accurate and complete delivery details.</li>
        <li>The Company is not responsible for delivery failures due to incorrect address or contact details.</li>
    </ul>

    <h2>11. International Shipping</h2>
    <ul>
        <li>Currently, we do not offer international shipping unless explicitly mentioned on the website.</li>
    </ul>

    <h2>12. Changes to Shipping Policy</h2>
    <p>The Company reserves the right to modify this Shipping & Delivery Policy at any time without prior notice. Changes will be updated on this page.</p>

    <h2>13. Contact Information</h2>
    <p>For shipping or delivery-related queries:</p>
    <div class="contact-info">
        <strong>Subcity International Marketing Pvt Ltd</strong><br/>
        📍 Address: Vill Paliguri, Jagiroad, Morigaon, Assam – 782410, India<br/>
        📞 Mobile: 8638407127<br/>
        📧 Email: subcityinternational22@gmail.com
    </div>


<style>
    {`
    <style>
        body {
            font-family: Arial, sans-serif;
            line-height: 1.6;
            color: #333;
            max-width: 800px;
            margin: 0 auto;
            padding: 20px;
        }
        h1, h2, h3 {
            color: #2c3e50;
        }
        .contact-info {
            background-color: #f9f9f9;
            padding: 15px;
            border-left: 5px solid #2c3e50;
            margin: 20px 0;
        }
        .warning {
            background-color: #fff3cd;
            padding: 10px;
            border-radius: 5px;
            display: inline-block;
        }
        ul {
            margin-bottom: 20px;
        }
    </style>
    `}
</style>
     </section>
     
     </> 
   
  );
}

export default Shipping;